"use client";

import { m } from "framer-motion";

export default function AnimatedText({ 
  text, 
  el: Wrapper = "span", 
  className, 
  staggerDelay = 0.05,
  initialDelay = 0,
  children // fallback to children if text isn't provided
}) {
  const defaultContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: staggerDelay,
        delayChildren: initialDelay,
      },
    },
  };

  const defaultItem = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.21, 0.47, 0.32, 0.98],
      },
    },
  };

  if (!text) {
    return (
      <Wrapper className={className}>
        <m.span
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={defaultContainer}
          style={{ display: "inline-block" }}
        >
          {children}
        </m.span>
      </Wrapper>
    );
  }

  // Split text into words for staggered animation
  const words = text.split(" ");

  return (
    <Wrapper className={className}>
      <m.span
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={defaultContainer}
        style={{ display: "inline-block", whiteSpace: "pre-wrap" }}
      >
        {words.map((word, index) => (
          <m.span
            key={index}
            variants={defaultItem}
            style={{ display: "inline-block" }}
          >
            {word}{index < words.length - 1 ? " " : ""}
          </m.span>
        ))}
      </m.span>
    </Wrapper>
  );
}
